import { Component, OnInit } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { Router, ActivatedRoute } from "@angular/router";
import { CustomHttp } from "../../../common/customHttp.service";
import { ApiUrl } from "../../../common/apiUrls";
import { FormGroup, Validators, FormBuilder } from "@angular/forms";
import { ValidationService } from "../../../common/validationservice";
import { MainAppComponent } from "../../../layout/layout.component";
import "rxjs/add/operator/map";
import {
  JobCardDDLModel,
  OilGradeDDLModel,
  SampleModel,
  GraphTempTypeDDLModel,
  EquipmentCategory,
} from "../../../common/viewModels/Analysis/SampleModel";
import {
  SamplingPointsModel,
  SpIdSearchFields,
} from "../../../common/viewModels/GlobalRegistry/SampPointModel";
declare var $: any;
import { FormatService } from "../../../common/formatService";
import { ReportTemplateTypesEnum } from "../../../common/enumcontainer.enum";
@Component({
  selector: "addeditsample",
  templateUrl: "./addsample.component.html",
  //styleUrls: ['./addsample.component.scss']
})
export class AddEditSampleStatus implements OnInit {
  addSampleForm: FormGroup;
  isSubmitted: boolean = false;
  lstEquipmentCategory: EquipmentCategory[];
  lstJobCards: JobCardDDLModel[];
  lstOilGrades: OilGradeDDLModel[];
  lstCharacteristics: any[];
  lstChars: any[];
  lstJobCardChars: any[];
  lstGraphTypes: GraphTempTypeDDLModel[];
  lstSpIds: SpIdSearchFields[];
  lstJobCardSpIds: SpIdSearchFields[];
  lstEquimnts: any;
  lstJobCardEquipments: any;
  lstSamplingPnts: SamplingPointsModel[];
  sampleDto: SampleModel;
  lstReportTypes: any[];
  lstComponents: any[];
  lstSampleTypes: any[];
  lstLubricants: any[];
  lstShips: any[];
  SpId: number;
  jobCardId: number;
  lstCustomerChars: any;
  lstEditCharIds: any;
  isEditPage: boolean = false;
  lstSpIdChars: any;
  lstNaviChars: any;
  showNaviFileds: boolean = false;
  hasLubricantChars: boolean = false;
  showDatalist: boolean = false;
  lstSpidsEquipmentNames:any[];

  constructor(
    public _router: Router,
    private _formBuilder: FormBuilder,
    private _http: CustomHttp,
    private _appUrl: ApiUrl,
    private _route: ActivatedRoute,
    private _validationService: ValidationService,
    private _mApp: MainAppComponent,
    private _toastrService: ToastrService,
    private _formatService: FormatService
  ) {}

  ngOnInit() {
    this.createAddSampleForm();
    this.GetJobCradsForDDL();
    this.GetOilGradesForDDL();
    //this.GetCharacteristicsForDDL();
    this.GetGraphTemplateTypesForDDL();
    this.GetMinSamplingPntsInfo();
    // this.GetMinEquipmentInfo();
    this.GetReportTemplatesMinInfoList();
    this.GetComponents();
    this.GetSampleTypes();
    this.GetLubricantsMinInfoList();
    this.GetShipsMinInfoList();
    this.GetEquipmentCategoryForDDL();
    if (
      this._route.snapshot.params["id"] != null &&
      this._route.snapshot.params["id"] != undefined &&
      this._route.snapshot.params["id"] != 0
    ) {
      this.isEditPage = true;
      this.GetSampleById(this._route.snapshot.params["id"]);
    } else {
      this.GetCharacteristicsForDDL();
    }
  }

  createAddSampleForm() {
    this.addSampleForm = this._formBuilder.group({
      SampleId: [0],
      JobCardId: [
        "",
        Validators.compose([
          Validators.required,
          this._validationService.ValidateDropdownList,
        ]),
      ],
      SampleNo: [
        "",
        Validators.compose([
          Validators.minLength(1),
          Validators.maxLength(100),
        ]),
      ],
      SampleTakenBy: [
        "",
        Validators.compose([Validators.minLength(1), Validators.maxLength(50)]),
      ],
      SamplingPointId: [
        "",
        Validators.compose([
          Validators.minLength(1),
          Validators.maxLength(100),
        ]),
      ],
      ComponentId: [
        "",
        Validators.compose([
          Validators.minLength(1),
          Validators.maxLength(100),
        ]),
      ],
      SampledDate: [null, Validators.required],
      SpId: [
        "",
        Validators.compose([
          Validators.required,
          this._validationService.ValidateDropdownList,
        ]),
      ],
      EquipmentName: [""],
      ReservoirQty: [
        "",
        Validators.compose([Validators.minLength(1), Validators.maxLength(20)]),
      ],
      RunningHrs: [
        "",
        Validators.compose([Validators.minLength(1), Validators.maxLength(20)]),
      ],
      //Lubricant: ['',Validators.compose([Validators.minLength(1), Validators.maxLength(100)])],
      OilGradeId: [
        "",
        Validators.compose([
          Validators.required,
          this._validationService.ValidateDropdownList,
        ]),
      ],
      OilGradeName: [""],
      CharIds: ["", Validators.compose([Validators.required])],
      SampleDescription: [
        "",
        Validators.compose([
          Validators.minLength(1),
          Validators.maxLength(1000),
        ]),
      ],
      GraphTemplateTypeId: [
        "",
        Validators.compose([
          Validators.required,
          this._validationService.ValidateDropdownList,
        ]),
      ],
      Remarks: [
        "",
        Validators.compose([
          Validators.minLength(1),
          Validators.maxLength(1000),
        ]),
      ],
      EquipmentCategoryId: [""],
      EnvironmentalConditionDuringSampling: [
        "",
        Validators.compose([
          Validators.minLength(1),
          Validators.maxLength(1000),
        ]),
      ],
      MiscInfo: [
        "",
        Validators.compose([
          Validators.minLength(1),
          Validators.maxLength(1000),
        ]),
      ],
      FilterType: [
        "",
        Validators.compose([
          Validators.minLength(1),
          Validators.maxLength(1000),
        ]),
      ],
      FilterChangeDate: [null],
      LastOilChangeDate: [null],

      ReportTemplateTypeId: [""],
      LstSampleChars: [""],
      SampleTypeId: [
        "",
        Validators.compose([
          Validators.required,
          this._validationService.ValidateDropdownList,
        ]),
      ],
      ShipId: [""],
      HrsSinceLastOilChange: [
        "",
        Validators.compose([Validators.minLength(1), Validators.maxLength(50)]),
      ],
      LubricantTypeId: [""],
      HrsSinceLastOilAdditionQuantity: [
        "",
        Validators.compose([
          Validators.minLength(1),
          Validators.maxLength(100),
        ]),
      ],
      TotalHmr: [
        "",
        Validators.compose([
          Validators.minLength(1),
          Validators.maxLength(100),
        ]),
      ],
      TopUpVolume: [
        "",
        Validators.compose([
          Validators.minLength(1),
          Validators.maxLength(100),
        ]),
      ],
      TypeOfOil: [
        "",
        Validators.compose([
          Validators.minLength(1),
          Validators.maxLength(100),
        ]),
      ],
      AnalystName: [
        "",
        Validators.compose([
          Validators.minLength(1),
          Validators.maxLength(100),
        ]),
      ],
      Quantity: [
        "",
        Validators.compose([
          Validators.minLength(1),
          Validators.maxLength(1000),
        ]),
      ],
      LubeMake: [
        "",
        Validators.compose([Validators.maxLength(200)]),
      ],
      FreshOil: [false],
      HMRAfterOilChange: [
        "",
        Validators.compose([Validators.maxLength(50)]),
      ],
      RefBarCode: [
        "",
        Validators.compose([Validators.maxLength(50)]),
      ],
    });
  }

  GetJobCradsForDDL() {
    this._mApp.ShowLoader();
    this._http.get(this._appUrl.GetJobcradsForDDL).subscribe(
      (data) => {
        this._mApp.HideLoader();
        this.lstJobCards = data.json().Result;
      },
      (error) => {
        this._mApp.HideLoader();
        //this._toastrService.error(error.json().Result, '');
      }
    );
  }
  GetEquipmentCategoryForDDL() {
    this._mApp.ShowLoader();
    this._http.get(this._appUrl.GetEquipmentCategoryForDDL).subscribe(
      (data) => {
        this._mApp.HideLoader();
        this.lstEquipmentCategory = data.json().Result;
      },
      (error) => {
        this._mApp.HideLoader();
        //this._toastrService.error(error.json().Result, '');
      }
    );
  }

  GetOilGradesForDDL() {
    this._mApp.ShowLoader();
    this._http.get(this._appUrl.GetOilGradesForDDL).subscribe(
      (data) => {
        this._mApp.HideLoader();
        this.lstOilGrades = data.json().Result;
      },
      (error) => {
        this._mApp.HideLoader();
        //this._toastrService.error(error.json().Result, '');
      }
    );
  }

  GetCharacteristicsForDDL() {
    this._mApp.ShowLoader();
    this._http.get(this._appUrl.GetCharacteristics).subscribe(
      (data) => {
        this._mApp.HideLoader();
        this.lstCharacteristics = data.json().Result;
        this.lstChars = data.json().Result;
      },
      (error) => {
        this._mApp.HideLoader();
        //this._toastrService.error(error.json().Result, '');
      }
    );
  }

  GetGraphTemplateTypesForDDL() {
    this._mApp.ShowLoader();
    this._http.get(this._appUrl.GetGraphTempleteTypeList).subscribe(
      (data) => {
        this._mApp.HideLoader();
        this.lstGraphTypes = data.json().Result;
      },
      (error) => {
        this._mApp.HideLoader();
        //this._toastrService.error(error.json().Result, '');
      }
    );
  }

  GetSampleById(id: number) {
    this._mApp.ShowLoader();
    this._http
      .get(this._appUrl.GetSampleById + this._route.snapshot.params["id"])
      .subscribe(
        (data) => {
          this._mApp.HideLoader();
          if (data.json() != null) {
            var response = data.json().Result;
            this.lstEditCharIds = data.json().Result.CharIds;
            this.lstSpIdChars = data.json().Result.CharIds;
            this.SpId = response.SpId;
            this.jobCardId = response.JobCardId;
            this.GetEquipmentsFromJobCard(response.JobCardId, false);
            response.SampledDate = this._formatService.formatNewDate(
              response.SampledDate
            );
            this.addSampleForm.setValue(response);
          }
        },
        (error) => {
          this._mApp.HideLoader();
          this._toastrService.error(error.json().Result, "");
        }
      );
  }

  onSubmit() {
    this.isSubmitted = true;
    if (this.addSampleForm.valid) {
      var sampleDto = this.addSampleForm.value;
      sampleDto.SampledDate = this._formatService.formatDate(
        sampleDto.SampledDate
      );
       sampleDto.FilterChangeDate = this._formatService.formatDate(
        sampleDto.FilterChangeDate
      );
       sampleDto.LastOilChangeDate = this._formatService.formatDate(
        sampleDto.LastOilChangeDate
      );
      if (!(sampleDto.LubricantTypeId > 0)) sampleDto.LubricantTypeId = null;

      this._mApp.ShowLoader();
      sampleDto.TotalCharIds = this.lstCharacteristics.map(function (a) {
        return a.CharacteristicId;
      });
      this._http.post(this._appUrl.AddUpdateSample, sampleDto).subscribe(
        (data) => {
          this._mApp.HideLoader();
          this._toastrService.success(data.json().Result, "");
          this._router.navigate(["/samplestatus"]);
        },
        (error) => {
          this._mApp.HideLoader();
          this._toastrService.error(error.json().Result, "");
        }
      );
    } else {
      this.addSampleForm.controls["JobCardId"].markAsTouched;
    }
  }

  Clear() {
    this.addSampleForm.reset();
  }

  BindSpId(jobCardId) {
    // let jobCardId=val.value
    this._mApp.ShowLoader();
    this._http.get(this._appUrl.PopulateSpIdValues + jobCardId).subscribe(
      (data) => {
        this.lstSpIds = data.json().Result;
        this.lstJobCardSpIds = this.lstSpIds;
        this._mApp.HideLoader();
      },
      (error) => {
        this._mApp.HideLoader();
        this._toastrService.error(error.json().Result);
      }
    );
  }

  BindSamplePtandEquipmnt(spId) {
    this._mApp.ShowLoader();
    let sampleId = this.addSampleForm.controls["SampleId"].value;
    // if (!(sampleId > 0))
    this.GetSpIdChars(spId);
    this._http.get(this._appUrl.PopulateSamplePtandEquipment + spId).subscribe(
      (data) => {
        this._mApp.HideLoader();
        var result = data.json().Result;
        if (result != null && result != undefined) {
          this.addSampleForm.controls["SamplingPointId"].setValue(
            result.SamplingPointId
          );
          this.addSampleForm.controls["EquipmentName"].setValue(
            result.SpidId
          );
          this.addSampleForm.controls["OilGradeId"].setValue(result.OilGradeId);
          //this.addSampleForm.controls['GraphTemplateTypeId'].setValue(result.GraphTemplateTypeId);
          this.addSampleForm.controls["ComponentId"].setValue(
            result.ComponentId
          );
          this.addSampleForm.controls["ReservoirQty"].setValue(
            result.ReservoirQty
          );
        }
      },
      (error) => {
        this._mApp.HideLoader();
        this._toastrService.error(error.json().Result);
      }
    );
  }

  PopulateValuesBasedOnSpidId(spidId) {
    this._mApp.ShowLoader();
    this.lstSpIdChars = null;
    this._http
      .get(this._appUrl.PopulateValuesBasedOnSpidId + spidId)
      .subscribe(
        (data) => {
          this._mApp.HideLoader();
          var res = data.json().Result;
          if (res != null) {
            if (res.SpidId != null && res.SpidId != "" && res.SpidId > 0) {
              this.GetSpIdChars(res.SpidId);
            }
            this.addSampleForm.controls["SamplingPointId"].setValue(
              res.SamplingPointId
            );
            this.addSampleForm.controls["OilGradeId"].setValue(res.OilGradeId);
            // this.addSampleForm.controls['GraphTemplateTypeId'].setValue(res.GraphTemplateTypeId);
            this.addSampleForm.controls["SpId"].setValue(res.SpidId);
            this.addSampleForm.controls["ComponentId"].setValue(
              res.ComponentId
            );
            this.addSampleForm.controls["ReservoirQty"].setValue(
              res.ReservoirQty
            );
          }
        },
        (error) => {
          this._mApp.HideLoader();
          this._toastrService.error(error.json().Result);
        }
      );
  }

  GetSpIdChars(spId) {
    // this.addSampleForm.controls['CharIds'].setValue(null);
    // this.lstSpIdChars = null;
    this._http.get(this._appUrl.GetSpIdCharsList + spId).subscribe(
      (data) => {
        let reportTypeId =
          this.addSampleForm.controls["ReportTemplateTypeId"].value;
        let lubTypeId = this.addSampleForm.controls["LubricantTypeId"].value;
        var res = data.json().Result;
        if (res.lstSampleChars.length > 0) {
          this.lstSpIdChars = res.lstCharIds;
          if (this.lstSpIdChars.length > 0) {
            this.addSampleForm.controls["CharIds"].setValue(this.lstSpIdChars);
          } else {
            if (
              reportTypeId == ReportTemplateTypesEnum.Navi &&
              lubTypeId > 0 &&
              this.lstNaviChars != null &&
              this.lstNaviChars != undefined &&
              this.hasLubricantChars
            )
              this.addSampleForm.controls["CharIds"].setValue(
                this.lstNaviChars
              );
            else if (
              this.lstJobCardChars != null &&
              this.lstJobCardChars != undefined
            )
              this.addSampleForm.controls["CharIds"].setValue(
                this.lstJobCardChars
              );
          }
        } else {
          this.lstSpIdChars = null;
          if (
            reportTypeId == ReportTemplateTypesEnum.Navi &&
            lubTypeId > 0 &&
            this.lstNaviChars != null &&
            this.lstNaviChars != undefined &&
            this.hasLubricantChars
          )
            this.addSampleForm.controls["CharIds"].setValue(this.lstNaviChars);
          else if (
            this.lstJobCardChars != null &&
            this.lstJobCardChars != undefined
          )
            this.addSampleForm.controls["CharIds"].setValue(
              this.lstJobCardChars
            );
        }
      },
      (error) => {
        this._toastrService.error(error.json().Result);
      }
    );
  }

  GetMinEquipmentInfo() {
    this._http.get(this._appUrl.GetMinEquipmentInfo).subscribe(
      (data) => {
        if (data.json().Result != null) this.lstEquimnts = data.json().Result;
      },
      (error) => {
        //this._toastrService.error(error.json().Result);
      }
    );
  }

  GetMinSamplingPntsInfo() {
    this._http.get(this._appUrl.GetMinSamplingPntsInfo).subscribe(
      (data) => {
        if (data.json().Result != null)
          this.lstSamplingPnts = data.json().Result;
      },
      (error) => {
        //this._toastrService.error(error.json().Result);
      }
    );
  }

  GetReportTemplatesMinInfoList() {
    this._http.get(this._appUrl.GetReportTemplatesMinInfoList).subscribe(
      (data) => {
        if (data.json().Result != null)
          this.lstReportTypes = data.json().Result;
      },
      (error) => {
        //this._toastrService.error(error.json().Result);
      }
    );
  }

  GetShipsMinInfoList() {
    this._http.get(this._appUrl.GetShipMinInfoList).subscribe(
      (data) => {
        if (data.json().Result != null) this.lstShips = data.json().Result;
      },
      (error) => {
        //this._toastrService.error(error.json().Result);
      }
    );
  }

  GetEquipmentsFromJobCard(id, isFromDDr) {
    if (isFromDDr) {
      this.addSampleForm.controls["SamplingPointId"].setValue(null);
      this.addSampleForm.controls["OilGradeId"].setValue(null);
      this.addSampleForm.controls["GraphTemplateTypeId"].setValue(null);
      this.addSampleForm.controls["SpId"].setValue(null);
      this.addSampleForm.controls["ComponentId"].setValue(null);
      this.addSampleForm.controls["CharIds"].setValue(null);
      this.addSampleForm.controls["EquipmentName"].setValue(null);

      this.lstSpIdChars = null;
    }
    this.BindSpId(id);
    this._http.get(this._appUrl.GetEquipmentsFromJobCard + id).subscribe(
      (data) => {
        var res = data.json().Result;
        if (isFromDDr) {
          this.addSampleForm.controls["ReportTemplateTypeId"].setValue(
            res.ReportTemplateTypeId
          );
          this.addSampleForm.controls["SampleTypeId"].setValue(
            res.SampleTypeId
          );
          this.addSampleForm.controls["GraphTemplateTypeId"].setValue(
            res.GraphTemplateTypeId
          );
        }
        let reportTypeId =
          this.addSampleForm.controls["ReportTemplateTypeId"].value;
        let lubTypeId = this.addSampleForm.controls["LubricantTypeId"].value;
        let shipId = this.addSampleForm.controls["ShipId"].value;

        if (res.lstChars.length > 0) {
          if (
            !(reportTypeId == ReportTemplateTypesEnum.Navi && lubTypeId > 0)
          ) {
            this.lstCharacteristics = res.lstChars;
            this.lstJobCardChars = this.lstCharacteristics.map(function (a) {
              return a.CharacteristicId;
            });
            //this.lstJobCardChars =res.lstChars;;
          } else if (
            reportTypeId == ReportTemplateTypesEnum.Navi &&
            lubTypeId > 0 &&
            this.isEditPage
          ) {
            this.GetLubricantCharsById(isFromDDr);
          }
        } else if (
          reportTypeId == ReportTemplateTypesEnum.Navi &&
          lubTypeId > 0 &&
          this.isEditPage
        ) {
          this.GetLubricantCharsById(isFromDDr);
        } else {
          this.GetCharacteristicsForDDL();
        }

        if (res) {
          this.lstEquimnts = res.LstEquipments;
          this.lstSpidsEquipmentNames = res.spidlist;
          this.lstJobCardEquipments = this.lstEquimnts;
          this.lstCustomerChars = res.LstCustomerChars;
        }

        if (isFromDDr) {
          this.addSampleForm.controls["ReportTemplateTypeId"].setValue(
            res.ReportTemplateTypeId
          );

          this.addSampleForm.controls["SampleTypeId"].setValue(
            res.SampleTypeId
          );
          this.addSampleForm.controls["GraphTemplateTypeId"].setValue(
            res.GraphTemplateTypeId
          );
          reportTypeId =
            this.addSampleForm.controls["ReportTemplateTypeId"].value;
          lubTypeId = this.addSampleForm.controls["LubricantTypeId"].value;
          if (reportTypeId == ReportTemplateTypesEnum.Navi && lubTypeId > 0) {
            this.GetLubricantCharsById(isFromDDr);
          } else {
            this.addSampleForm.controls["CharIds"].setValue(
              res.LstCustomerChars
            );
          }
        }

        //show or hide navi related fields
        if (reportTypeId == ReportTemplateTypesEnum.Navi)
          this.showNaviFileds = true;
        else this.showNaviFileds = false;
        //

        // Binding equipments and spids based on ship id when report type is navi
        if (reportTypeId == ReportTemplateTypesEnum.Navi && shipId > 0)
          this.GetEquipmentsBasedOnShip(shipId);
      },
      (error) => {
        this._toastrService.error(error.json().Result);
      }
    );
  }

  GetComponents() {
    this._http.get(this._appUrl.GetComponentMinInfoList).subscribe(
      (data) => {
        if (data.json().Result != null) this.lstComponents = data.json().Result;
      },
      (error) => {
        //this._toastrService.error(error.json().Result)
      }
    );
  }

  GetSampleTypes() {
    this._http.get(this._appUrl.GetMinInfoSampleTypes).subscribe(
      (data) => {
        if (data.json().Result != null)
          this.lstSampleTypes = data.json().Result;
      },
      (error) => {
        //this._toastrService.error(error.json().Result);
      }
    );
  }

  GetLubricantsMinInfoList() {
    this._http.get(this._appUrl.GetLubricantsMinInfoList).subscribe(
      (data) => {
        if (data.json().Result != null) this.lstLubricants = data.json().Result;
      },
      (error) => {
        //this._toastrService.error(error.json().Result);
      }
    );
  }

  GetLubricantCharsById(isFromDdr) {
    this.lstCharacteristics = null;

    let reportTypeId =
      this.addSampleForm.controls["ReportTemplateTypeId"].value;
    let lubTypeId = this.addSampleForm.controls["LubricantTypeId"].value;
    let jobCardId = this.addSampleForm.controls["JobCardId"].value;

    if (reportTypeId == ReportTemplateTypesEnum.Navi) {
      this.showNaviFileds = true;
      if (lubTypeId > 0) {
        this._mApp.ShowLoader();
        this._http
          .get(this._appUrl.GetListOfLubricantCharsForDDr + lubTypeId)
          .subscribe(
            (data) => {
              this._mApp.HideLoader();
              var res = data.json().Result;
              if (res.length > 0) {
                this.hasLubricantChars = true;
                this.lstCharacteristics = res;
                let charIds = this.lstCharacteristics.map(function (a) {
                  return a.CharacteristicId;
                });
                this.lstNaviChars = charIds;
                if (
                  isFromDdr &&
                  (this.lstSpIdChars == null || this.lstSpIdChars == undefined)
                ) {
                  this.addSampleForm.controls["CharIds"].setValue(charIds);
                  this.lstNaviChars = charIds;
                }
              } else if (
                (this.lstCharacteristics == null ||
                  this.lstCharacteristics == undefined) &&
                jobCardId > 0
              ) {
                this.GetJobCardChars(jobCardId, isFromDdr);
                this.hasLubricantChars = false;
              } else {
                this.GetCharacteristicsForDDL();
                this.hasLubricantChars = false;
              }
            },
            (error) => {
              this._mApp.HideLoader();
              this._toastrService.error(error.json().Result);
            }
          );
      } else if (
        (this.lstCharacteristics == null ||
          this.lstCharacteristics == undefined) &&
        isFromDdr &&
        jobCardId > 0
      ) {
        this.GetJobCardChars(jobCardId, isFromDdr);
      } else this.GetCharacteristicsForDDL();
    } else if (
      (this.lstCharacteristics == null ||
        this.lstCharacteristics == undefined) &&
      isFromDdr &&
      jobCardId > 0
    ) {
      this.showNaviFileds = false;
      this.addSampleForm.controls["ShipId"].setValue(null);
      this.addSampleForm.controls["LubricantTypeId"].setValue(null);
      this.GetJobCardChars(jobCardId, isFromDdr);
    } else {
      this.showNaviFileds = false;
      this.GetCharacteristicsForDDL();
      this.addSampleForm.controls["CharIds"].setValue(null);
      this.addSampleForm.controls["ShipId"].setValue(null);
      this.addSampleForm.controls["LubricantTypeId"].setValue(null);
    }
  }

  GetJobCardChars(jobCardId, isFromDdr) {
    this._http.get(this._appUrl.GetCharsBasedonJobCard + jobCardId).subscribe(
      (data) => {
        var res = data.json().Result;
        if (res.length > 0) {
          this.lstCharacteristics = res;
          this.lstJobCardChars = this.lstCharacteristics.map(function (a) {
            return a.CharacteristicId;
          });
        }
        if (
          isFromDdr &&
          this.lstCharacteristics != null &&
          this.lstCharacteristics != undefined &&
          (this.lstSpIdChars == null || this.lstSpIdChars == undefined)
        ) {
          let charIds = this.lstCharacteristics.map(function (a) {
            return a.CharacteristicId;
          });
          this.addSampleForm.controls["CharIds"].setValue(charIds);
        }
        if (
          this.lstCharacteristics == null ||
          this.lstCharacteristics == undefined
        ) {
          //&& isFromDdr, removed this condition in loop
          let spid = this.addSampleForm.controls["SpId"].value;
          //
          if (!(spid > 0))
            this.addSampleForm.controls["CharIds"].setValue(null);
          this.GetCharacteristicsForDDL();
        }
      },
      (error) => {
        this._toastrService.error(error.json().Result);
      }
    );
  }

  GetEquipmentsBasedOnShip(shipId) {
    this._mApp.ShowLoader();
    this._http.get(this._appUrl.GetEquipmentsBasedOnShip + shipId).subscribe(
      (data) => {
        this._mApp.HideLoader();
        var res = data.json().Result;
        if (
          res.lstEquipments != null &&
          res.lstEquipments != undefined &&
          res.lstEquipments.length > 0
        )
          this.lstEquimnts = res.lstEquipments;
        else this.lstEquimnts = this.lstJobCardEquipments;

        if (
          res.lstSpids != null &&
          res.lstSpids != undefined &&
          res.lstSpids.length > 0
        )
          this.lstSpIds = res.lstSpids;
        else this.lstSpIds = this.lstJobCardSpIds;
      },
      (error) => {
        this._mApp.HideLoader();
        this._toastrService.error(error.json().Result);
      }
    );
  }

  ShowHideNaviFields(reportTemplateId) {
    this.addSampleForm.controls["ShipId"].setValue(null);
    this.addSampleForm.controls["LubricantTypeId"].setValue(null);
    this.addSampleForm.controls["EquipmentName"].setValue(null);
    this.addSampleForm.controls["SpId"].setValue(null);
    this.lstSpIdChars = null;
    let jobCardId = this.addSampleForm.controls["JobCardId"].value;
    this.GetLubricantCharsById(true);
    if (reportTemplateId == ReportTemplateTypesEnum.Navi) {
      this.showNaviFileds = true;
    } else {
      this.showNaviFileds = false;
      this.GetSpIdChars(0);
      if (jobCardId > 0) this.GetEquipmentsFromJobCard(jobCardId, false);
    }
  }

  ShowDatalist() {
    this.showDatalist = true;
  }
}
